module.exports = __webpack_public_path__ + "assets/3-best-mid-market-sales-jobs.6f022ffb.png";